import { Link, useLocation } from 'react-router-dom'
import { UserMenu } from './user-menu'
import {
  LayoutDashboard,
  Users,
  Send,
  FileText,
  MessageSquare,
  Settings,
  LifeBuoy,
  Gift,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Separator } from '@/components/ui/separator'
import { useMobileSheet } from '@/hooks/use-mobile'

type NavItem = {
  readonly label: string
  readonly href: string
  readonly icon: React.ComponentType<{ readonly className?: string }>
}

// Customer-facing navigation. The KNWN4 staff super-admin dashboard
// lives at /super-admin and is intentionally NOT linked from the
// customer sidebar — staff reach it by direct URL.
const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { label: 'Leads', href: '/leads', icon: Users },
  { label: 'Campaigns', href: '/campaigns', icon: Send },
  { label: 'Content', href: '/content', icon: FileText },
  { label: 'Inbox', href: '/inbox', icon: MessageSquare },
  { label: 'Settings', href: '/settings', icon: Settings },
  { label: 'Refer & Earn', href: '/affiliate', icon: Gift },
  { label: 'Support', href: '/support', icon: LifeBuoy },
] as const

export function MobileSidebar() {
  const location = useLocation()
  const { open, setOpen } = useMobileSheet()

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="left" className="w-72 p-0">
        <SheetHeader className="border-b border-sidebar-border px-6 py-4">
          <SheetTitle className="text-lg font-bold">DealCloser</SheetTitle>
        </SheetHeader>

        <ScrollArea className="flex-1 px-3 py-4">
          <nav className="flex flex-col gap-1">
            {NAV_ITEMS.map((item) => {
              const isActive =
                location.pathname === item.href ||
                (item.href === '/dashboard' && location.pathname === '/')

              return (
                <Link
                  key={item.href}
                  to={item.href}
                  onClick={() => setOpen(false)}
                  className={cn(
                    'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                    'hover:bg-accent hover:text-accent-foreground',
                    isActive
                      ? 'bg-accent text-accent-foreground'
                      : 'text-muted-foreground',
                  )}
                >
                  <item.icon className="h-5 w-5 shrink-0" />
                  <span>{item.label}</span>
                </Link>
              )
            })}
          </nav>
        </ScrollArea>

        <Separator />

        <div className="p-3">
          <UserMenu />
        </div>
      </SheetContent>
    </Sheet>
  )
}
